import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  selectDefaultMessage,
  selectOfferChatDealType,
  selectOfferChatGaLabel,
  selectOfferChatOfferId,
  selectOfferChatOfferType,
  selectShouldSendDefaultMessage,
} from 'shared/map-search/selectors/chatModal';

import { getSourceParams } from '../utils/getSourceParams';

export const useSrcChat = (isOpen: boolean) => {
  const defaultMessage = useSelector(selectDefaultMessage);
  const shouldSendDefaultMessage = useSelector(selectShouldSendDefaultMessage);
  const gaLabel = useSelector(selectOfferChatGaLabel);
  const offerId = useSelector(selectOfferChatOfferId);
  const dealType = useSelector(selectOfferChatDealType);
  const offerType = useSelector(selectOfferChatOfferType);
  const source = getSourceParams();

  return useMemo(() => {
    if (!offerId || !isOpen) {
      return null;
    }

    /* istanbul ignore next */
    const src =
      `/dialogs/?hostType=frame&offerId=${offerId}` +
      `${dealType ? `&dealType=${dealType}` : ''}` +
      `${offerType ? `&offerType=${offerType}` : ''}` +
      `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
      '&pageType=Listing' +
      '&listingType=map' +
      `${defaultMessage ? '&defaultMessage=' + encodeURIComponent(defaultMessage) : ''}` +
      `${shouldSendDefaultMessage ? '&sendDefaultMessage=1' : ''}` +
      `${source ? `&parentSource=${source}` : ''}`;

    return src;
  }, [dealType, defaultMessage, gaLabel, isOpen, offerId, offerType, shouldSendDefaultMessage, source]);
};
